import { useEffect, useState } from "react";
import { Search, UserPlus, Check } from "lucide-react";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";

export function CustomerPicker({ onPick, disabled }) {
  const [q, setQ] = useState("");
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) {
      return undefined;
    }
    const t = setTimeout(() => api.get("/customers", { params: { q } }).then(({ data }) => setList(data)).catch(() => {}), 250);
    return () => clearTimeout(t);
  }, [q, open]);

  if (disabled) return null;
  return (
    <div className="space-y-2" data-testid="customer-picker">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-[var(--muted)]" />
        <Input value={q} onFocus={() => setOpen(true)} onChange={(e) => { setQ(e.target.value); setOpen(true); }}
          placeholder="Cerca cliente esistente (schede clienti e appuntamenti)" className="pl-9" data-testid="customer-search-input" />
      </div>
      {open && (
        <div className="rounded-xl border border-[var(--border)] bg-white max-h-56 overflow-y-auto divide-y divide-[var(--border)]" data-testid="customer-results">
          {list.length === 0 && <p className="p-3 text-sm text-[var(--muted)]">Nessun cliente trovato: compila i campi sotto per creare una nuova scheda.</p>}
          {list.map((c, i) => (
            <button type="button" key={`${c.id}-${c.appointment_id}-${i}`} onClick={() => { onPick(c); setOpen(false); setQ(""); }}
              className="w-full text-left p-3 hover:bg-[var(--surface-2)] flex items-start gap-2" data-testid={`customer-result-${i}`}>
              <Check className="h-4 w-4 mt-0.5 text-[var(--muted)]" />
              <span className="min-w-0">
                <span className="block font-medium truncate">{c.name}</span>
                <span className="block text-xs text-[var(--muted)] truncate">{c.phone} · {c.address} · {c.source === "cliente" ? "scheda cliente" : `da appuntamento ${c.date || ""}`}</span>
              </span>
            </button>
          ))}
          <button type="button" onClick={() => { onPick(null); setOpen(false); }} className="w-full text-left p-3 text-sm font-semibold text-[var(--primary-hover)] flex items-center gap-2" data-testid="customer-new-button">
            <UserPlus className="h-4 w-4" /> Nuovo cliente
          </button>
        </div>
      )}
    </div>
  );
}
